const sec = document.querySelector(".sec");
const min = document.querySelector(".min");
const hours = document.querySelector(".hours");
const date = new Date();
const baseSec = date.getSeconds();
const baseMin = date.getMinutes();
const baseHours = date.getHours();

let minRotate = baseMin * 6;
let secRotate = baseSec * 6;
let hoursRotate = baseHours * 30 + baseMin * 0.5;
hours.style.transform = `translate(-50%, -100%) rotate(${hoursRotate}deg)`;
min.style.transform = `translate(-50%, -100%) rotate(${minRotate}deg)`;
sec.style.transform = `translate(-50%, -100%) rotate(${secRotate}deg)`;
setInterval(() => {
  sec.style.transform += " rotate(6deg)";
}, 1000);
setInterval(() => {
  min.style.transform += " rotate(0.1deg)";
}, 1000);
setInterval(() => {
  hours.style.transform += " rotate(0.017deg)";
}, 10000);
